import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export interface IOnboardingStep5ViewProps extends IOnboardingStepProps {}

export const OnboardingStep5 = (props: IOnboardingStepProps) => {
  return <View {...props} />;
};
